const PENDING_GTFS_FILE_KEY = '__atlasPendingGtfsFile';

type WindowWithPendingGtfs = Window & {
  [PENDING_GTFS_FILE_KEY]?: File;
};

export const emitGtfsFileDropped = (file: File): void => {
  (window as WindowWithPendingGtfs)[PENDING_GTFS_FILE_KEY] = file;
  window.dispatchEvent(new CustomEvent('gtfsFileDropped', { detail: { file } }));
};

export const consumePendingGtfsFile = (): File | null => {
  const holder = window as WindowWithPendingGtfs;
  const pending = holder[PENDING_GTFS_FILE_KEY] || null;
  if (pending) {
    delete holder[PENDING_GTFS_FILE_KEY];
  }
  return pending;
};

/**
 * A dropped UK BODS / TransXChange feed (or a re-dropped Atlas export) → ingest
 * into the network store as a hosted feed (PRD-05b). Distinct from `gtfsFileDropped`
 * (which imports a GTFS zip into the Fixed Routes drawer): a full network belongs in the
 * store (browsable/forkable), not flattened into the per-session working set.
 */
export const NETWORK_FEED_DROPPED_EVENT = 'networkFeedDropped';

export const emitNetworkFeedDropped = (file: File): void => {
  window.dispatchEvent(new CustomEvent(NETWORK_FEED_DROPPED_EVENT, { detail: { file } }));
};
